import { Card, Col, Divider, Icon, Row, Skeleton } from 'antd';
import React from 'react';
import SeoScore from '../../analysis/report/summary/SeoScore';
import ReportCategoryStatistics from '../../analysis/report/ReportCategoryStatistics';

const defaultValues = {
    url: 'https://your-url-goes-here.com',
    seoReportScore: {
        totalSectionsCount: 51,
        scoreData: {
            score: 66,
            passed: 39,
            warning: 0,
            failed: 12,
        },
    },
    category: {
        score: 50,
        passed: 13,
        warning: 5,
        failed: 2,
    },
};

export default function DefaultReport() {
    return (
        <div className="default-template">
            <Card
                title={
                    <Card.Meta
                        title={defaultValues.url}
                        description="SEO Report"
                    />
                }
            >
                <SeoScore
                    scoreData={defaultValues.seoReportScore.scoreData}
                    totalSectionsCount={defaultValues.seoReportScore.totalSectionsCount}
                />
            </Card>

            <Card
                className="seo-issues"
                title="Common SEO issues"
                extra={
                    <ReportCategoryStatistics
                        score={defaultValues.category.score}
                        passed={defaultValues.category.passed}
                        warning={defaultValues.category.warning}
                        failed={defaultValues.category.failed}
                    />
                }
            >
                <Row
                    type="flex"
                    justify="space-around"
                    align="middle"
                >
                    <Col
                        span={10}
                        className="flexbox align-center"
                    >
                        <Icon
                            type="check-circle"
                            theme="filled"
                            className="passed status-icon"
                        />
                        <Skeleton
                            title={true}
                            paragraph={false}
                        />
                    </Col>
                    <Col span={14}>
                        <Skeleton
                            title={false}
                            paragraph={{ rows: 2 }}
                        />
                    </Col>
                </Row>
                <Divider />
                <Row
                    type="flex"
                    justify="space-around"
                    align="middle"
                >
                    <Col
                        span={10}
                        className="flexbox align-center"
                    >
                        <Icon
                            type={'close-circle'}
                            theme="filled"
                            className="failed status-icon"
                        />
                        <Skeleton
                            title={true}
                            paragraph={false}
                        />
                    </Col>
                    <Col span={14}>
                        <Skeleton
                            title={false}
                            paragraph={{ rows: 2 }}
                        />
                    </Col>
                </Row>
                <Divider />
                <Row
                    type="flex"
                    justify="space-around"
                    align="middle"
                >
                    <Col
                        span={10}
                        className="flexbox align-center"
                    >
                        <Icon
                            type="exclamation-circle"
                            theme="filled"
                            className="warning status-icon"
                        />
                        <Skeleton
                            title={true}
                            paragraph={false}
                        />
                    </Col>
                    <Col span={14}>
                        <Skeleton
                            title={false}
                            paragraph={{ rows: 2 }}
                        />
                    </Col>
                </Row>
                <Divider />
                <Row
                    type="flex"
                    justify="space-around"
                    align="middle"
                >
                    <Col
                        span={10}
                        className="flexbox align-center"
                    >
                        <div className="status-icon default-icon"></div>
                        <Skeleton
                            title={true}
                            paragraph={false}
                        />
                    </Col>
                    <Col span={14}>
                        <Skeleton
                            title={false}
                            paragraph={{ rows: 2 }}
                        />
                    </Col>
                </Row>
            </Card>
        </div>
    );
}
